module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/e71dba2ccaa69d866c3a022104e7bfad.png";